export default class ProductSizeGuideDrawer extends Core.Component {
  onMount() {
    const drawerModal = Core.Components.getComponent('drawer-modal');

    if (drawerModal) {
      const embedModalBtnEl = this.el.querySelector('[data-drawer-close]');

      this.events.register(embedModalBtnEl, 'click', e => {
        e.stopPropagation();
        e.preventDefault();

        const closeEvent = new CustomEvent('product-page-drawer:close', { bubbles: true });
        this.el.dispatchEvent(closeEvent);
      });
    }
  }
}
